module.exports = __webpack_public_path__ + "img/partner_people.2f044b45.svg";